export default __webpack_public_path__ + "static/media/check mark.b6d7f48d.png";